import React from 'react';
import { IconProps } from '.';

const SvgDocumentData = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M11 7v11h2V7h-2ZM7.5 13v5h2v-5h-2ZM14.5 18V9.5h2V18h-2Z' />
      <path fill={color} fillRule='evenodd' d='M3 1h18v22H3V1Zm1.35 1.35h15.3v19.3H4.35V2.35Z' clipRule='evenodd' />
    </svg>
  );
};

export default SvgDocumentData;
